export const getPlatform = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  const isMobile = isAndroid || isIOS;

  const isMacOS = !isMobile && /Macintosh/.test(userAgent);
  const isWindows = !isMobile && /Windows/.test(userAgent);
  const isLinux = !isMobile && /Linux/.test(userAgent) && !isAndroid;

  const isApple = isMacOS || isIOS;

  if (isApple) {
    return 'apple';
  }

  if (isWindows) {
    return 'windows';
  }

  if (isLinux) {
    return 'linux';
  }

  if (isAndroid) {
    return 'android';
  }
};

window.getPlatform = getPlatform;